import { DarwinUpload } from 'components/darwin-ui';

type MakeBeforeUploadI18nArgs = {
  t: (key: string, vars?: Record<string, any>) => string;
  allowedTypes?: string[];
  maxSizeMB?: number;
  onError?: (msg: string) => void;
  textMessages?: {
    wrongType: string;
    sizeExceeded: string;
  };
};

export function makeBeforeUpload({
  t,
  allowedTypes = [''],
  maxSizeMB = 5,
  onError,
  textMessages = {
    wrongType: '',
    sizeExceeded: '',
  },
}: MakeBeforeUploadI18nArgs) {
  const err = (key: string, vars?: Record<string, any>) => {
    const msg = t(key, vars);
    onError?.(msg);
  };

  return (file: File) => {
    const isAllowedType = allowedTypes.includes(file.type);
    if (!isAllowedType) {
      err(textMessages.wrongType);
      return DarwinUpload.LIST_IGNORE;
    }

    const isLtSize = file.size / 1024 / 1024 < maxSizeMB;
    if (!isLtSize) {
      err(textMessages.sizeExceeded, { maxSize: maxSizeMB });
      return DarwinUpload.LIST_IGNORE;
    }

    return true;
  };
}
